var React = require('react');

function CustomAdditions (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

CustomAdditions.displayName = "CustomAdditions";

CustomAdditions.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = CustomAdditions;

CustomAdditions.default = CustomAdditions;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/CustomAdditions.svg
// module id = 639
// module chunks = 168707334958949